import Navbar from "CommonComponents/Navbar/Navbar";
import FooterA from "Pages/Home/FooterA/FooterA";
import FooterB from "Pages/Home/FooterB/FooterB";

import bg1 from "Assets/Images/BusinessCategory/category1.png";
import "./styles.scss";

const Index = () => {
  document.title = "داپ اَپ ؛ کش-بک-با-داپ-اَپ";
  return (
    <div className="cashback-dapapp-screen">
      <header>
        <Navbar />
      </header>
      <main className="px-2 ">
        <div className="title-cashback-dapapp ">
          <h1 className="text-dark">
            {" "}
            <span className="text-dap-success">کش‌بک</span> چیست؟
          </h1>
        </div>
        <section className="all-img-cashback">
          <div className="hero-image container p-0 ">
            <img src={bg1} alt="" className="w-100 hero-img " />
          </div>
        </section>
        <div className="content-box-cashback  container">
          <p className="m-0 my-3">
            کش‌بک در واقع ایده جدیدی در تجارت الکترونیک است که از نظر مفهومی
            شبیه به تخفیف گرفتن است، اما کاربرد آن متفاوت است. در کش‌بک
            (Cashback Reward Platform) به نوعی از نظر روانی، مشتریان را تشویق می
            کنیم تا به سمت خرید بیشتر بروند. در این سازوکار جدید، درصدی از مبلغ
            کل خرید به عنوان جایزه (reward) به حساب فرد و یا کیف پول الکترونیک
            او بازگردانده می‌شود و او می‌تواند در خریدهای بعدی از این اعتبار
            استفاده کند و یا آن را به طور نقدی دریافت کند.
          </p>
          <h2 className="text-dark mt-5">
            تفاوت تخفیف با <span className="text-dap-success">کش‌بک</span>:
          </h2>
          <p className="m-0 my-3">
            تفاوت تخفیف با کش‌بک بسیار زیاد است. گفتنی است که کش‌بک و تخفیف به
            جز افزایش درآمد مشتری، نقطه اشتراک دیگری ندارند.
          </p>
          <p className="m-0 my-3">
            تخفیف‌ها به صورت کاملا دوره‌ای و کوتاه‌مدت ارائه می‌شوند. در هر کدام
            از انواع تخفیف، ارائه‌دهندگان تخفیف تلاش دارند تا مشتری با برند آنها
            آشنا شود و نهایتا به تقاضای بیشتر محصول یا خدمت منجر شود. کش‌بک اما
            به صورت دائمی و پیوسته در دسترس مشتریان قرار دارد. مشتری در هر خرید،
            درصدی از هزینه پرداخت شده را پس می‌گیرد.
          </p>
          <p className="m-0 my-3">
            هدف از برخی از انواع تخفیف، تخلیه انبار است. کش‌بک اما در هر روش خود
            تلاش دارد، مشتری را به برند وفادار کند.
          </p>
          <p className="m-0 my-3">
            روش اجرای تخفیف و زمان درست بسیار مهم است. برای همین اگر تخفیف به
            درستی اجرا نشود به ارزش برند آسیب وارد می‌کند. اما در کش‌بک بدون
            آسیب به ارزش برند، درصدی از هزینه به حساب یا کیف پول الکترونیکی
            مشتری باز می‌گردد.
          </p>
          <p className="m-0 my-3">
            تخفیف یک استراتژی برای فروش بالا در کوتاه‌مدت است و اگر در بلند‌مدت
            اجرا شود، نام تجاری یا برند ارزش خود در نزد مشتری را از دست می‌دهد.
            کش‌بک اما در طولانی‌مدت باعث افزایش وفاداری به برند می‌گردد.
          </p>
          <h2 className="text-dark mt-5">
            <span className="text-dap-success">کش‌بک</span> , روش نوین بازاریابی
            :
          </h2>
          <p className="m-0 my-3">
            کش‌بک با توجه به اینکه روش نوین بازاریابی در انواع کسب و کارها از
            جمله فروشگاه‌های زنجیره‌ای، فروشگاه‌های اینترنتی و برندها می‌باشد،
            می‌تواند در زمینه ارائه خدمات به سازمان‌ها و نهادهای مختلف به کار
            گرفته شود و به عنوان یک استراتژی بازاریابی موثر برای فروشگاه‌های
            زنجیره‌ای، فروشگاه‌های اینترنتی و برندها عمل کند و برای آن‌ها
            مشتریان وفاداری را به ارمغان بیاورد، که در آن سو نیز نیاز مصرف
            کنندگان هم برطرف خواهد شد که در نهایت این فرآیند برد- برد خواهد
            بود. 
          </p>
          <h2 className="text-dark mt-5">
            <span className="text-dap-success">کش‌بک</span> در ایران :
          </h2>
          <p className="m-0 my-3">
            درحال حاضر داپ‌اَپ به عنوان اولین پلتفرم پاداش نقدی خرید (کش‌بک) در
            ایران، با همکاری شرکای تجاری خود در شبکه پرداخت بانکی کشور (شرکت های
            به پرداخت ملت، و تجارت الکترونیک پارسیان) خدمت کش‌بک را به
            مردم شریف ایران ارائه می‌دهد. اما در این بین فروشگاه‌های زنجیره‌ای،
            فروشگاه‌های اینترنتی و برندها نیز می‌توانند، ضمن عقد قرارداد با
            داپ‌اَپ این خدمت نوین را به مشتریان خود ارائه دهند. بدون شک با گسترش
            و جا افتادن چنین روش‌های فروشی، هم تولیدکنندگان و عرضه‌کنندگان
            می‌توانند، به کسب‌وکار خود رونق دهند، هم‌ مصرف‌کنندگان نیز با شرایط
            و تسهیلات بیشتر و بهتری نیاز‌های خود را مرتفع سازند.
          </p>
        </div>
      </main>
      <footer>
        <FooterA />
        <FooterB />
      </footer>
    </div>
  );
};

export default Index;
